export default {
  scriptUrl: "https://www.paypalobjects.com/api/checkout.js"
};
